export { fs } from "./filesystem.atom";
export {
	exists,
	mkdir,
	readDir,
	readTextFile,
	remove,
	rename,
	writeTextFile,
} from "./filesystem.internal";
